// import { Padding } from "@mui/icons-material";

export const Bio = {
    name: "Siva A",
    roles: [
      "Software Engineer",
      "ML Enthusiast",
      "Developer"
    ],
    description:
      "I specialize in machine learning, NLP, and backend development, designing smart systems that turn data into clear insights. My work focuses on building effective data pipelines, optimizing backend processes, and creating privacy-focused applications.",
    github: "https://github.com/Siva50005",
    resume:
      "https://drive.google.com/file/d/12SGv9juKyC_DsFb8jv1iIDw2M27wHaNU/view?usp=drive_link",
    linkedin: "https://www.linkedin.com/in/siva-a-090260220/",
    twitter: "https://x.com/sillyboi396",
    insta: "https://www.instagram.com/siva_11_1000_10/",
  };
  
  export const skills = [
    {
      title: "Machine Learning",
      skills: [
        {
          name: "Pytorch",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/refs/heads/master/icons/pytorch/pytorch-original.svg",
        },
        {
          name: "Scikit-Learn",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/refs/heads/master/icons/scikitlearn/scikitlearn-original.svg",
        },
        {
          name: "Pandas",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/refs/heads/master/icons/pandas/pandas-original.svg",
        },
        {
          name: "Numpy",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/refs/heads/master/icons/numpy/numpy-original.svg",
        },
        {
          name: "Langchain",
          image:
            "../../assets/logos/langchain-original.svg",
        },
      ],
    },

    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
        // {
        //   name: "Graph Ql",
        //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
        // },
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "Flask",
          image:
              "https://raw.githubusercontent.com/devicons/devicon/refs/heads/master/icons/flask/flask-original.svg"
        },
        {
          name: "FastApi",
          image:
              "https://raw.githubusercontent.com/devicons/devicon/refs/heads/master/icons/fastapi/fastapi-original.svg"
        },
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/refs/heads/master/icons/git/git-original.svg",
        },
        {
          name: "Docker",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/refs/heads/master/icons/docker/docker-original.svg",
        },
        {
          name: "Postman",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/refs/heads/master/icons/postman/postman-original.svg",
        },
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTW__uSLRRyu3eyIC5YZjdkJ5In4BlTgbvow&s",
      role: "Software Engineer",
      company: "Multicoreware Inc.",
      date: "July 2024 - Present",
      desc: <ul>
                <li><b>AMD POS Checkout (POC):</b> Built a retail checkout pipeline integrating YOLOv8 object detection, CNN-LSTM anomaly detection (shoplifting), and LLM-based notification generation. Converted model to ONNX and optimized for AMD iGPU/NPU deployment.</li>
                <li><b>VLM Benchmarking:</b> Evaluated and benchmarked medical VLMs (Blip2, Moondream2, LLaVA-Med) on AMD NUC. Quantized Llama-2 using Ryzen AI AWQ (w4abf16) for NPU inference, achieving 3.2 tokens/sec with ~52% memory utilization.</li>
                <li><b>Harman (DMS Porting):</b> Ported the DriverSense pipeline to Qualcomm SA6155 using SNPE SDK. Integrated and quantized (int8/int16) 5 CNN models (BodyPosture, EyeGaze, EyeHeatmaps, EyeLocalization, FaceTracker), achieving an average CPU usage of 4.38% and 116 MB memory on board. Worked on FuSa-compliant LLD documentation, UML diagrams, and test specifications.</li>
            </ul>,
      skills: [
        "Pytorch",
        "Ultralytics",
        "ONNX",
        "SNPE SDK",
        "LLM",
        "Computer Vision",
      ],
      doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
    },
    {
      id: 1,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTW__uSLRRyu3eyIC5YZjdkJ5In4BlTgbvow&s",
      role: "Junior Engineer",
      company: "Multicoreware Inc.",
      date: "January 2024 - June 2024",
      desc: <ul>
                <li><b>Table Extraction Pipeline:</b> Created a pipeline to detect and extract tables from PDF files using DETR (Detection Transformer) and OCR, exporting table information to CSV files.</li>
                <li><b>Record Linkage with Siamese Networks:</b> Developed a record linkage solution with bi-directional LSTM Siamese networks, reaching 97.5% test accuracy.</li>
            </ul>,
      skills: [
        "Pytorch",
        "Deep Learning",
        "Computer Vision",
        "NLP",
      ],
      doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
    },
  ];
  

  export const projects = [
    {
      id: 0,
      title: "Cancerlytics",
      date: "June - July 2023",
      description:
        "A Cancer prediction app designed to assess the likelihood of developing breast cancer based on various characteristics of the cell nuclei. Utilized the Logistic Regression model to solve the problem of imbalanced data. (Achieved an accuracy of 97.2%). Deployed a web app with GUI to work with the model.",
      image:
        "https://github.com/Siva50005/cancerlytics-breast-cancer-prediction/blob/master/Cancerlytics_demo.png?raw=true",
      tags: [
        "Python",
        "Pandas",
        "Scikit-learn",
        "Streamlit",
      ],
      category: "web app",
      github: "https://github.com/Siva50005/cancerlytics-breast-cancer-prediction",
      webapp: "https://cancerlytics-breast-cancer-prediction.streamlit.app/", //Link for the live hosted app
    },
    {
      id: 1,
      title: " FireDet",
      date: "October - December 2022",
      description:
        "A Fire detection system which uses an efficient deep learning model to detect fire in a CCTV footage. (Works even with a computer with less resources.). Utilized the SqueezeNet architecture to solve the problem of increased model size. (model size: less than 5 mb)",
      image:
        "https://github.com/Siva50005/fire-det/blob/master/fire_detection_methodology.png?raw=true",
      tags: [
        "React Js", 
        "FastAPI", 
        "Node Js", 
        "Pytorch", 
        "Pandas"
      ],
      category: "machine learning",
      github: "https://github.com/Siva50005/fire-det",
      webapp: "",
    },
    {
      id: 2,
      title: "Agriman",
      date: "September - October 2021",
      description:
        "An agriculture management system for crop and resource management. Designed and implemented a database model for easy CRUD operations.",
      image:
        "https://www.lovelycoding.org/wp-content/uploads/2022/08/Crop-Management-System.webp",
      tags: [
        "Java",
        "Java Swing and AWT",
        "MySQL",
      ],
      category: "web app",
      github: "https://github.com/Siva50005/AgriMan",
      webapp: "",
      member: [
        {
          name: "Siva A",
          img: "https://avatars.githubusercontent.com/u/75238464?v=4",
          linkedin: "https://www.linkedin.com/in/siva-a-090260220/",
          github: "https://github.com/Siva50005",
        },
        {
          name: "Aparna J",
          img: "https://avatars.githubusercontent.com/u/75220885?v=4",
          linkedin: "https://www.linkedin.com/in/aparna-jayathirth-4b45261b4/",
          github: "https://github.com/aparna8902",
        },
        {
          name: "Abhinandhan S",
          img: "https://avatars.githubusercontent.com/u/75251112?v=4",
          linkedin: "https://www.linkedin.com/in/abhinandhan-s/",
          github: "https://github.com/STRIZERORTIX",
        },
        {
          name: "Shandilyathithyaa Ma",
          img: "https://avatars.githubusercontent.com/u/73104941?v=4",
          linkedin: "https://www.linkedin.com/in/shandilyathithyaa-manivannan-a760401bb/",
          github: "https://github.com/Shandilyathithyaa",
        },
        {
          name: "Yurekan R V",
          img: "https://avatars.githubusercontent.com/u/75236983?v=4",
          linkedin: "https://www.linkedin.com/in/yurekan-r-v-b30397220/",
          github: "https://github.com/yurekan",
        },
      ],
    },
  ];